var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;



//////////////////
// WEBPACK FOOTER
// (webpack)-merge/~/lodash/_nativeCreate.js
// module id = 80
// module chunks = 9